import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { toCalendarDate } from "../../../../../helper/dateTime";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { ReactComponent as Close } from "../../../../newLayout/assets/svgIcon/listView/Close.svg";
import {
  FilterOverlay,
  FilterDropdownPanel,
  PanelHeader,
  CloseBtn,
  PanelBody,
  ActionRow,
  CancelBtn,
  ApplyBtn,
} from "../../../components/table/index.styles";

const DateFilterDropdown = ({
  isOpen,
  onClose,
  label,
  activeValues,
  onApply,
  onClear,
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [hasSelection, setHasSelection] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (activeValues && activeValues.start && activeValues.end) {
        setStartDate(new Date(`${toCalendarDate(activeValues.start)}T00:00:00`));
        setEndDate(new Date(`${toCalendarDate(activeValues.end)}T00:00:00`));
        setHasSelection(true);
      } else {
        setStartDate(new Date());
        setEndDate(new Date());
        setHasSelection(false);
      }
    }
  }, [isOpen, activeValues]);
  
  useEffect(() => {
    if (!isOpen) return;
    const handler = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [isOpen, onClose]);

  const selectionRanges = {
    startDate,
    endDate,
    key: "selection",
  };

  const handleRange = ranges => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
    setHasSelection(true);
  };

  const handleApply = () => {
    const startStr = toCalendarDate(startDate);
    const endStr = toCalendarDate(endDate);
    onApply({ start: startStr, end: endStr });
    onClose();
  };

  const handleClear = () => {
    setStartDate(new Date());
    setEndDate(new Date());
    setHasSelection(false);
    onClear();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <FilterOverlay onClick={onClose} />
      <FilterDropdownPanel style={{ width: "auto" }}>
        <PanelHeader>
          Filter {label}
          <CloseBtn onClick={onClose}>
            <Close />
          </CloseBtn>
        </PanelHeader>
        <PanelBody style={{ padding: "0" }}>
          <DateRangePicker 
            ranges={[selectionRanges]} 
            onChange={handleRange} 
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            direction="horizontal"
          />
        </PanelBody>
        <ActionRow>
          <CancelBtn type="button" onClick={handleClear}>Clear</CancelBtn>
          <ApplyBtn type="button" $active={hasSelection} onClick={handleApply} disabled={!hasSelection}>
            Apply Filter
          </ApplyBtn>
        </ActionRow>
      </FilterDropdownPanel>
    </>
  );
};

export default DateFilterDropdown;
